import { type ChangeEvent, type FC } from 'react';
import styled from 'styled-components';
import { Icon, IconType } from '../Props/Icon/Icon';

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  withSearchIcon?: boolean;
};

export const SearchInput: FC<SearchInputProps> = ({ value, onChange, placeholder, className, withSearchIcon }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  return (
    <InputContainer>
      <StyledInput className={className} type="text" placeholder={placeholder} value={value} onChange={handleChange} />
      {withSearchIcon ? <Icon icon={IconType.SEARCH} width={16} height={16} fill="transparent" /> : null}
    </InputContainer>
  );
};

const InputContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledInput = styled.input`
  width: 100%;
  border: none;
  outline: none;

  ::placeholder {
    color: ${({ theme }) => theme.colors.normal};
  }
`;
